(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-configurator-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const NS = '__pplrConfiguratorFormEnhancer';
  if (window[NS]?.installed) return;
  window[NS] = { installed: true };

  const CHANGE_EVENT = 'pplr:configurator:change';

  const SWATCH_SELECTOR = '.pplr-swatch-element[data-val]';
  const WRAPPER_SELECTOR = '.pplr-wrapper';
  const OPTION_TEXT_SELECTOR = '.pplr_option_text_span';
  const CART_ADD_FORM_SELECTOR = 'form[action="/cart/add"]';
  const REQUIRED_CLASS = 'pplr_red_wrapper';

  const DIMENSIONS_WRAPPER_SELECTOR = '.pplr-wrapper[class*="pplr-dimensions-"]';
  const DIMENSIONS_SELECTED_SWATCH_SELECTOR = '.pplr-swatch-element.selected[data-val], .pplr-swatch-element.pplrimage.selected[data-val]';
  const DERIVED_PROP_KEYS = {
    width: 'Largeur de cintre',
    stem: 'Longueur de potence'
  };

  const escapeCss = (value) => {
    const v = String(value ?? '');
    if (window.CSS?.escape) return window.CSS.escape(v);
    // Minimal fallback: escape backslash + double-quote for attribute selectors.
    return v.replace(/[\\"]/g, '\\$&');
  };

  const getOptionsMap = () => window.PPLRConfigurator?.getConfiguratorOptionsMap?.() || {};

  const isElementVisible = (el) => {
    if (!(el instanceof Element)) return false;
    const style = window.getComputedStyle?.(el);
    if (!style) return true;
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    // offsetParent is null for display:none ancestors (except fixed).
    if (el instanceof HTMLElement && el.offsetParent === null && style.position !== 'fixed') return false;
    return true;
  };

  const getElementRawCode = (el) => {
    if (!(el instanceof HTMLElement)) return '';
    return String(
      el.getAttribute('data-cfg-code') ||
        el.dataset?.cfgCode ||
        el.getAttribute('data-value') ||
        el.getAttribute('data-val') ||
        ''
    ).trim();
  };

  const hasOptionsMap = (optionsMap) =>
    optionsMap && typeof optionsMap === 'object' && Object.keys(optionsMap).length > 0;

  const isKnownCode = (optionsMap, candidate) => {
    if (!hasOptionsMap(optionsMap)) return false;
    const key = String(candidate || '').trim();
    if (!key) return false;
    return Object.prototype.hasOwnProperty.call(optionsMap, key);
  };

  const getSwatchCanonicalCode = (el, optionsMap) => {
    if (!(el instanceof HTMLElement)) return '';

    const dataCfgCode = String(el.getAttribute('data-cfg-code') || '').trim();
    const datasetCfgCode = String(el.dataset.cfgCode || '').trim();

    // If metadata isn't ready, never fall back to data-val (might be a title).
    if (!hasOptionsMap(optionsMap)) {
      return dataCfgCode || datasetCfgCode;
    }

    const dataValue = String(el.getAttribute('data-value') || '').trim();
    const dataVal = String(el.getAttribute('data-val') || '').trim();

    const candidates = [dataCfgCode, datasetCfgCode, dataValue, dataVal].filter(Boolean);
    const known = candidates.find((c) => isKnownCode(optionsMap, c));
    if (known) return String(known).trim();

    // If nothing matches the options map, do not fall back to data-val/data-value (could be a title).
    return dataCfgCode || datasetCfgCode;
  };

  const getDisplayValue = (code, optionsMap) => {
    const key = String(code || '').trim();
    if (!key) return '';
    const title = String(optionsMap?.[key]?.title || '').trim();
    const reference = String(optionsMap?.[key]?.reference || '').trim();
    const base = title || key;
    return reference ? `${base} (ref: ${reference})` : base;
  };

  const pickBestSelectedCode = ({ wrap, input, optionsMap }) => {
    if (!(wrap instanceof HTMLElement)) return '';
    if (!(input instanceof HTMLInputElement)) return '';

    const desired = String(input.value || '').trim();
    const frame = String(input.getAttribute('data-frame') || '').trim();

    const candidates = Array.from(
      wrap.querySelectorAll('.pplr-swatch-element.selected, .pplr-swatch-element.pplrimage.selected, .pplr-drop-item.active')
    ).filter((n) => n instanceof HTMLElement);

    if (!candidates.length) return '';

    let bestCode = '';
    let bestScore = -Infinity;

    for (const el of candidates) {
      const raw = getElementRawCode(el);
      const canonical = getSwatchCanonicalCode(el, optionsMap) || raw;
      if (!canonical) continue;

      let score = 0;
      if (desired && canonical === desired) score += 100;
      if (frame && String(el.getAttribute('data-frame') || '').trim() === frame) score += 20;
      if (el.classList.contains('active')) score += 10;
      if (isElementVisible(el)) score += 10;

      if (score > bestScore) {
        bestScore = score;
        bestCode = canonical;
      }
    }

    return String(bestCode || '').trim();
  };

  const persistSwatchCodeDataset = (root = document) => {
    // IMPORTANT: do NOT mutate data-val (PPLR can depend on it).
    // We only persist the canonical code in dataset for later use.
    root.querySelectorAll(SWATCH_SELECTOR).forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      // Keep it simple: store the raw code. We do NOT mutate PPLR attributes.
      const code = getElementRawCode(el);
      if (!code) return;
      if (el.dataset.cfgCode !== code) el.dataset.cfgCode = code;
    });
  };

  const upsertHiddenPropertyInput = (form, propKey, value) => {
    if (!(form instanceof HTMLFormElement)) return false;
    if (!propKey) return false;

    const selector = `input[name="properties[${escapeCss(propKey)}]"]`;
    const existing = form.querySelector(selector);

    const nextValue = String(value ?? '').trim();
    if (!nextValue) {
      if (existing) {
        existing.remove();
        return true;
      }
      return false;
    }

    let input = existing;
    if (!(input instanceof HTMLInputElement)) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${propKey}]`;
      input.dataset.pplrDerived = 'dimensions';
      form.appendChild(input);
    }

    if (input.value !== nextValue) {
      input.value = nextValue;
      return true;
    }

    return false;
  };

  const parseDimensionsFromCode = (code) => {
    const raw = String(code || '').trim();
    if (!raw) return null;

    // Expected examples:
    // - CINTRE-IKONIK-ROAD-AXL-420-100
    // - CINTRE-IKONIK-ROAD-AXP-370-85
    const m = raw.match(/-(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/);
    if (!m) return null;

    const width = String(m[1] || '').trim();
    const stem = String(m[2] || '').trim();
    if (!width || !stem) return null;

    return {
      width: `${width} MM`,
      stem: `${stem} MM`
    };
  };

  const getSelectedDimensionsCode = (root = document) => {
    const wrappers = Array.from(root.querySelectorAll(DIMENSIONS_WRAPPER_SELECTOR)).filter(
      (n) => n instanceof HTMLElement
    );

    if (!wrappers.length) return '';

    // Prefer visible wrappers.
    const ordered = wrappers.sort((a, b) => (isElementVisible(b) ? 1 : 0) - (isElementVisible(a) ? 1 : 0));

    for (const wrap of ordered) {
      const sw = wrap.querySelector(DIMENSIONS_SELECTED_SWATCH_SELECTOR);
      if (!(sw instanceof HTMLElement)) continue;
      if (!isElementVisible(sw)) continue;
      const code = getElementRawCode(sw);
      if (code) return code;
    }

    return '';
  };

  const syncDerivedHandlebarDimensions = (root = document) => {
    const code = getSelectedDimensionsCode(root);
    const parsed = parseDimensionsFromCode(code);

    let didChange = false;
    document.querySelectorAll(CART_ADD_FORM_SELECTOR).forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;

      if (!parsed) {
        if (upsertHiddenPropertyInput(form, DERIVED_PROP_KEYS.width, '')) didChange = true;
        if (upsertHiddenPropertyInput(form, DERIVED_PROP_KEYS.stem, '')) didChange = true;
        return;
      }

      if (upsertHiddenPropertyInput(form, DERIVED_PROP_KEYS.width, parsed.width)) didChange = true;
      if (upsertHiddenPropertyInput(form, DERIVED_PROP_KEYS.stem, parsed.stem)) didChange = true;
    });

    if (didChange) {
      // Force summary refresh (it listens to this event).
      document.dispatchEvent(new CustomEvent(CHANGE_EVENT));
    }

    return didChange;
  };

  const emitConfiguratorChange = ({ input, wrap, code }) => {
    if (!(input instanceof HTMLInputElement)) return;
    const key = input.name?.match(/^properties\[(.*)\]$/)?.[1] || '';

    document.dispatchEvent(
      new CustomEvent(CHANGE_EVENT, {
        detail: {
          key,
          name: input.name || '',
          code: String(code || '').trim(),
          main: wrap instanceof HTMLElement ? String(wrap.dataset.main || '') : ''
        }
      })
    );
  };

  const syncInputCfgCodeFromWrapper = (wrap) => {
    if (!(wrap instanceof HTMLElement)) return;

    const input = wrap.querySelector('input[name^="properties["]');
    if (!(input instanceof HTMLInputElement)) return;

    const optionsMap = getOptionsMap();

    // Prefer the best matching selected element (handles multiple `.selected` incl. hidden ones).
    const codeFromSelected = pickBestSelectedCode({ wrap, input, optionsMap });
    const code = codeFromSelected || String(input.value || '').trim();
    if (!code) return;

    // Keep canonical code accessible in dataset + attribute, and keep input value human-readable.
    const prev = String(input.dataset.cfgCode || '').trim();

    const disabledState = input.disabled ? '1' : '0';
    const prevDisabledState = String(input.dataset.cfgDisabled || '');

    let shouldEmit = false;

    // Keep dataset + attribute aligned with the chosen code.
    if (prev !== code) {
      input.dataset.cfgCode = code;
      shouldEmit = true;
    } else if (input.dataset.cfgCode !== code) {
      input.dataset.cfgCode = code;
    }

    const displayValue = getDisplayValue(code, optionsMap) || code;
    if (input.value !== displayValue) {
      input.value = displayValue;
      shouldEmit = true;
    }

    if (prevDisabledState !== disabledState) {
      input.dataset.cfgDisabled = disabledState;
      // Disabled/enabled toggles affect summary inclusion.
      shouldEmit = true;
    }

    if (input.getAttribute('data-cfg-code') !== code) input.setAttribute('data-cfg-code', code);

    if (shouldEmit) {
      emitConfiguratorChange({ input, wrap, code });
      return true;
    }

    return false;
  };

  const syncAllInputsCfgCode = (root = document) => {
    let changes = 0;
    root.querySelectorAll(WRAPPER_SELECTOR).forEach((wrap) => {
      if (syncInputCfgCodeFromWrapper(wrap)) changes += 1;
    });
    return changes;
  };

  const updateOptionTextSpans = (root = document) => {
    const optionsMap = getOptionsMap();
    if (!Object.keys(optionsMap).length) return;

    root.querySelectorAll(WRAPPER_SELECTOR).forEach((wrap) => {
      if (!(wrap instanceof HTMLElement)) return;

      const txt = wrap.querySelector(OPTION_TEXT_SELECTOR);
      if (!txt) return;

      const input = wrap.querySelector('input[name^="properties["]');
      if (!(input instanceof HTMLInputElement)) return;

      const code = String(input.dataset.cfgCode || input.value || '').trim();
      if (!code) return;

      const title = String(optionsMap[code]?.title || '').trim();
      if (!title) return;

      const desired = ` - ${title}`;
      if (txt.textContent !== desired) {
        txt.textContent = desired;
      }
    });
  };

  const normalizeCartAddFormProperties = (form) => {
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches(CART_ADD_FORM_SELECTOR)) return;

    // Ensure we have the latest selected codes before submit.
    persistSwatchCodeDataset(form);
    syncAllInputsCfgCode(form);

    // Add derived properties (handlebar width/stem length) right before submit.
    syncDerivedHandlebarDimensions(document);

    // Force the submitted values to remain human-readable.
    form.querySelectorAll('input[name^="properties["]').forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const optionsMap = getOptionsMap();
      const code = String(input.dataset.cfgCode || '').trim();
      const displayValue = getDisplayValue(code, optionsMap) || String(input.value || '').trim();
      if (!displayValue) return;
      input.value = displayValue;
      if (code && input.getAttribute('data-cfg-code') !== code) input.setAttribute('data-cfg-code', code);
    });
  };

  const installPreSubmitHook = () => {
    // Last-moment normalization right before add-to-cart submit.
    document.addEventListener(
      'submit',
      (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        normalizeCartAddFormProperties(form);
      },
      true
    );
  };

  const STICKY_COVERS_SELECTOR = '.shopify-section-group-header-group, .product-information__media';

  const coveringBottom = (rect) => {
    let bottom = 0;
    document.querySelectorAll(STICKY_COVERS_SELECTOR).forEach((el) => {
      const box = el.getBoundingClientRect();
      if (!['sticky', 'fixed'].includes(getComputedStyle(el).position)) return;
      if (box.right <= rect.left || box.left >= rect.right) return;
      bottom = Math.max(bottom, box.bottom);
    });
    return bottom;
  };

  // PPLR scrolls a missing option 200px below the viewport top: under the sticky header, and under the media on mobile.
  const revealRequiredOption = (wrap) => {
    const settled = window.jQuery ? window.jQuery('html, body').promise() : Promise.resolve();
    settled.then(() =>
      setTimeout(() => {
        const rect = wrap.getBoundingClientRect();
        const delta = rect.top - coveringBottom(rect) - 16;
        if (delta < 0) window.scrollBy({ top: delta, behavior: 'smooth' });
      }, 50)
    );
  };

  const installRequiredObserver = () => {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        const wrap = m.target;
        if (!(wrap instanceof HTMLElement) || !wrap.matches(WRAPPER_SELECTOR)) continue;
        if (!wrap.classList.contains(REQUIRED_CLASS) || String(m.oldValue || '').includes(REQUIRED_CLASS)) continue;
        revealRequiredOption(wrap);
      }
    });

    mo.observe(document.body, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  };

  const installObserver = () => {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (!m.addedNodes?.length) continue;
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          persistSwatchCodeDataset(node);
          syncAllInputsCfgCode(node);
          updateOptionTextSpans(node);
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  };

  const init = () => {
    persistSwatchCodeDataset(document);
    syncAllInputsCfgCode(document);
    updateOptionTextSpans(document);
    syncDerivedHandlebarDimensions(document);

    // allow PPLR to finish initial render
    setTimeout(() => {
      persistSwatchCodeDataset(document);
      syncAllInputsCfgCode(document);
      updateOptionTextSpans(document);
      syncDerivedHandlebarDimensions(document);
    }, 300);

    installPreSubmitHook();
    installObserver();
    installRequiredObserver();

    // Single interaction hook to re-sync + update derived UI.
    const handleInteraction = (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;

      // PPLR conditions can enable/disable other wrappers as a side-effect.
      // Resync everything (we don't mutate PPLR state, so it's safe).
      syncAllInputsCfgCode(document);
      updateOptionTextSpans(document);
      syncDerivedHandlebarDimensions(document);
    };

    document.addEventListener('click', (e) => setTimeout(() => handleInteraction(e), 0), true);
    document.addEventListener('change', (e) => setTimeout(() => handleInteraction(e), 0), true);
  };

  window.addEventListener('pplrAppInitiated', init);
  if (window.PPLR || document.querySelector('.product-personalizer')) {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-configurator-options-json"] && !Shopify.designMode) return;
  try {
    (() => {
  const GLOBAL_KEY = 'PPLRConfigurator';
  const JSON_SELECTOR = '[data-configurator-options-json]';

  const api = (window[GLOBAL_KEY] = window[GLOBAL_KEY] || {});
  if (typeof api.getConfiguratorOptionsMap === 'function') return;

  let cachedText = null;
  let cachedMap = null;

  const buildMap = (items) => {
    const map = {};

    // Format B (array)
    if (Array.isArray(items)) {
      for (const it of items) {
        const code = it?.['Image Label Description'];
        if (!code) continue;
        const key = String(code).trim();
        if (!key) continue;
        map[key] = {
          title: String(it?.['Titre'] || key).trim(),
          description: String(it?.['Libellé long'] || '').trim(),
          reference: String(it?.['Référence'] || '').trim()
        };
      }
      return map;
    }

    // Format A (object)
    if (items && typeof items === 'object') {
      for (const [code, payload] of Object.entries(items)) {
        const key = String(code).trim();
        if (!key) continue;
        map[key] = {
          title: String(payload?.['Titre'] || key).trim(),
          description: String(payload?.['Libellé long'] || '').trim(),
          reference: String(payload?.['Référence'] || '').trim()
        };
      }
      return map;
    }

    return map;
  };

  api.getConfiguratorOptionsMap = ({ forceRefresh = false } = {}) => {
    const el = document.querySelector(JSON_SELECTOR);
    if (!el) {
      cachedMap = {};
      cachedText = null;
      return cachedMap;
    }

    const text = el.textContent || '{}';
    if (!forceRefresh && cachedMap && cachedText === text) return cachedMap;

    try {
      const raw = JSON.parse(text);
      const items = raw?.options ?? raw;
      cachedText = text;
      cachedMap = buildMap(items);
      return cachedMap;
    } catch (e) {
      // keep last good cache if any; otherwise empty
      console.error('[PPLRConfigurator] Error parsing configurator options JSON:', e);
      cachedText = text;
      cachedMap = cachedMap || {};
      return cachedMap;
    }
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-configurator-summary"] && !Shopify.designMode) return;
  try {
    (() => {
  const NS = '__pplrPdpPropsSpy';
  const CHANGE_EVENT = 'pplr:configurator:change';

  // Initialisation si nécessaire
  if (!window[NS]) {
    window[NS] = { installed: false };
  }

  // Si déjà installé, on arrête le script
  if (window[NS].installed) {
    console.log('[PPLR Props Spy] Already installed.');
    return;
  }

  // Début de l'initialisation

  const PROPS_SELECTOR = 'form[action="/cart/add"] input[name^="properties["]';
  const SUMMARY_ROOT_SELECTOR = '[data-configurator-summary-root]';
  const SUMMARY_SELECTOR = '[data-configurator-summary-items]';

  const EXCLUDED_PROP_KEYS = new Set([
    '_requireGravage',
    '_isGravage',
    '_pplr_preview'
  ]);

  const shouldIncludePropInput = (input) => {
    if (!input) return false;
    if (input.type === 'file') return false;
    return !input.disabled;
  };

  // Fonction pour placer le résumé avant les boutons
  const placeSummaryBeforeButtons = () => {
    const buttons = document.querySelector('.product-form-buttons');
    if (!buttons) return;

    const summaryRoot = document.querySelector(SUMMARY_ROOT_SELECTOR)?.parentNode;
    if (!summaryRoot) return;

    const parent = buttons.parentNode;
    if (!parent) return;

    if (summaryRoot.parentNode === parent && summaryRoot.nextSibling === buttons) return;
    parent.insertBefore(summaryRoot, buttons);
  };

  // Récupérer les options configurées et les résumer
  const renderSummary = (props) => {
    const optionsMap = window.PPLRConfigurator?.getConfiguratorOptionsMap?.() || {};

    const container = document.querySelector(SUMMARY_SELECTOR);
    if (!container) return;
    const ul = document.createElement('ul');
    Object.entries(props).forEach(([key, value]) => {
      const code = String(value).trim();
      const meta = optionsMap[code];

      const li = document.createElement('li');
      li.innerHTML = `${key}: <b>${meta ? meta.title : code}</b> ${meta && meta.reference ? `(ref: ${meta.reference})` : ''}`;
      ul.appendChild(li);
    });

    container.innerHTML = '';  // Vider l'ancien contenu
    container.appendChild(ul);
  };

  // Fonction pour récupérer les propriétés sélectionnées dans le formulaire
  const readSnapshot = () => {
    const inputs = Array.from(document.querySelectorAll(PROPS_SELECTOR));
    const props = {};

    inputs.forEach((el) => {
      if (!shouldIncludePropInput(el)) return;
      const name = el.getAttribute('name');
      const key = name?.match(/^properties\[(.*)\]$/)?.[1];
      if (!key || EXCLUDED_PROP_KEYS.has(key)) return;
      if (key) {
        const code = String(el.dataset?.cfgCode || el.value || '').trim();
        if (!code) return;
        props[key] = code;
      }
    });

    return props;
  };

  // Initialisation
  const init = () => {
    renderSummary(readSnapshot());
    placeSummaryBeforeButtons();  // Placer le résumé avant les boutons
  };

  // Re-render when the configurator signals a canonical code change.
  document.addEventListener(CHANGE_EVENT, () => {
    renderSummary(readSnapshot());
  });

  // Exécuter après l'initialisation de PPLR
  window.addEventListener('pplrAppInitiated', init);

  // Si déjà initialisé
  if (window.PPLR || document.querySelector('.product-personalizer')) {
    init();
  }

  window[NS].installed = true;
  console.log('[PPLR Props Spy] Initialization complete.');
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-configurator-tooltips"] && !Shopify.designMode) return;
  try {
    (() => {
  const OPTION_SELECTOR = '.pplr-swatch-element[data-val]';
  const TOOLTIP_SELECTOR = '.swtooltip';
  const META_CLASS = 'pplr-tooltip-meta';

  // Portal
  const PORTAL_ID = 'pplr-tooltip-portal';
  const PORTAL_CLASS = 'pplr-tooltip-portal';
  const OPEN_CLASS = 'pplr-tooltip-portal-open';
  const GAP = 10;

  const getProData = () => {
    try {
      const el = document.getElementById('adris-pro-color-data');
      return el ? JSON.parse(el.textContent) : null;
    } catch(e) { return null; }
  };

  const formatPlusPrice = (raw, reference) => {
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return '';
    const pro = getProData();
    if (pro && pro.isPro && reference) {
      const discounts = pro.discounts || {};
      const proDiscount = Number(discounts[reference]);
      if (Number.isFinite(proDiscount) && proDiscount > 0) {
        const proPrice = n - proDiscount;
        return proPrice > 0 ? `+ ${proPrice} €` : '';
      }
    }
    return `+ ${n} €`;
  };

  const getOptionsMap = () => {
    const fn = window.PPLRConfigurator?.getConfiguratorOptionsMap;
    if (typeof fn !== 'function') return {};
    return fn();
  };

  const ensurePortal = () => {
    let el = document.getElementById(PORTAL_ID);
    if (el) return el;

    el = document.createElement('div');
    el.id = PORTAL_ID;
    el.className = `${TOOLTIP_SELECTOR.replace('.', '')} ${PORTAL_CLASS}`; // "swtooltip pplr-tooltip-portal"
    // style minimal (le reste via CSS)
    el.style.position = 'fixed';
    el.style.left = '0px';
    el.style.top = '0px';
    el.style.zIndex = '999999';
    el.style.display = 'none';

    el.addEventListener('pointerleave', (e) => {
      if (isCoarsePointer()) return;
      if (currentAnchor && currentAnchor.contains(e.relatedTarget)) return;
      hidePortal();
    });

    document.body.appendChild(el);
    return el;
  };

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  // clientWidth/clientHeight excluent la scrollbar, contrairement à innerWidth/innerHeight
  const vw = () => document.documentElement.clientWidth;
  const vh = () => document.documentElement.clientHeight;

  const positionPortal = (portal, anchorEl) => {
    if (!portal || !anchorEl) return;

    const a = anchorEl.getBoundingClientRect();

    // Mesure du portal
    portal.style.visibility = 'hidden';
    portal.style.display = 'block';

    const pRect = portal.getBoundingClientRect();
    const pw = pRect.width || 300;
    const ph = pRect.height || 120;

    // Choix au-dessus / en-dessous
    const fitsBelow = (a.bottom + GAP + ph) <= (vh() - 8);
    const top = fitsBelow
      ? (a.bottom + GAP)
      : (a.top - GAP - ph);

    // Centrage horizontal + clamp dans la zone visible (hors scrollbar)
    const leftIdeal = a.left + (a.width / 2) - (pw / 2);
    const left = clamp(leftIdeal, 8, vw() - pw - 8);

    portal.style.left = `${left}px`;
    portal.style.top = `${clamp(top, 8, vh() - ph - 8)}px`;

    portal.style.visibility = 'visible';
  };

  let currentAnchor = null;
  let rafId = null;

  const showPortalFor = (swatchEl) => {
    if (!(swatchEl instanceof HTMLElement)) return;
    const sourceTooltip = swatchEl.querySelector(TOOLTIP_SELECTOR);
    if (!sourceTooltip) return;

    const portal = ensurePortal();

    // Copie du contenu (on ne déplace pas le node => on évite de casser le script externe)
    portal.innerHTML = sourceTooltip.innerHTML;

    // Bouton fermeture
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'pplr-portal-close';
    closeBtn.setAttribute('aria-label', 'Fermer');
    closeBtn.textContent = 'x';
    closeBtn.addEventListener('click', hidePortal);
    portal.insertBefore(closeBtn, portal.firstChild);

    // Marque l'ancre pour cacher l'original (via CSS)
    swatchEl.classList.add(OPEN_CLASS);
    currentAnchor = swatchEl;

    positionPortal(portal, swatchEl);

    // Reposition au scroll/resize (raf-throttle)
    const tick = () => {
      rafId = null;
      if (!currentAnchor) return;
      positionPortal(portal, currentAnchor);
    };

    const schedule = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(tick);
    };

    window.addEventListener('scroll', schedule, true);
    window.addEventListener('resize', schedule, true);

    // stocke pour cleanup
    portal._pplrCleanup = () => {
      window.removeEventListener('scroll', schedule, true);
      window.removeEventListener('resize', schedule, true);
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    };

    portal.style.display = 'block';
  };

  const hidePortal = () => {
    const portal = document.getElementById(PORTAL_ID);
    if (portal) {
      portal.style.display = 'none';
      portal.innerHTML = '';
      if (typeof portal._pplrCleanup === 'function') {
        portal._pplrCleanup();
        portal._pplrCleanup = null;
      }
    }
    if (currentAnchor) {
      currentAnchor.classList.remove(OPEN_CLASS);
      currentAnchor = null;
    }
  };

  const isCoarsePointer = () => window.matchMedia('(pointer: coarse)').matches;

  const bindPortalHandlers = (swatchEl) => {
    if (!(swatchEl instanceof HTMLElement)) return;
    if (swatchEl.dataset.portalBound === '1') return;

    // Hover desktop uniquement (sur touch: le bouton info prend le relais)
    swatchEl.addEventListener('pointerenter', () => { if (!isCoarsePointer()) showPortalFor(swatchEl); });
    swatchEl.addEventListener('pointerleave', (e) => {
      if (isCoarsePointer()) return;
      const portal = document.getElementById(PORTAL_ID);
      if (portal && portal.contains(e.relatedTarget)) return;
      hidePortal();
    });

    // Keyboard (desktop uniquement, focusin se declenche avant click sur mobile)
    swatchEl.addEventListener('focusin', () => { if (!isCoarsePointer()) showPortalFor(swatchEl); });
    swatchEl.addEventListener('focusout', () => { if (!isCoarsePointer()) hidePortal(); });

    swatchEl.dataset.portalBound = '1';
  };

  const addInfoBtn = (swatchEl) => {
    if (swatchEl.querySelector('.pplr-info-btn')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pplr-info-btn';
    btn.setAttribute('aria-label', 'Informations sur cette option');
    btn.textContent = '?';
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const portal = document.getElementById(PORTAL_ID);
      if (currentAnchor === swatchEl && portal && portal.style.display !== 'none') {
        hidePortal();
      } else {
        showPortalFor(swatchEl);
      }
    });
    swatchEl.appendChild(btn);
  };

  // If the shared helper isn't present or data isn't ready, no-op.
  let optionsMap = getOptionsMap();
  if (!Object.keys(optionsMap).length) return;

  const enhanceOne = (el) => {
    if (!(el instanceof HTMLElement)) return;

    // Bind portal regardless of metadata (sinon tooltip d'origine restera coupée)
    bindPortalHandlers(el);

    if (el.dataset.tooltipEnhanced === '1') return;

    const code = String(el.dataset.cfgCode || el.getAttribute('data-val') || '').trim();
    if (!code) return;

    const meta = optionsMap[code];
    const title = String(meta?.title || '').trim();
    const desc = String(meta?.description || '').trim();
    const reference = String(meta?.reference || '').trim();

    const priceRaw = el.getAttribute('data-pplr_price');
    const priceTxt = formatPlusPrice(priceRaw, reference);

    if (!title && !desc && !priceTxt && !reference) return;

    const tooltip = el.querySelector(TOOLTIP_SELECTOR);
    if (!tooltip) return;

    if (tooltip.querySelector(`.${META_CLASS}`)) {
      el.dataset.tooltipEnhanced = '1';
      return;
    }

    const wrap = document.createElement('div');
    wrap.className = META_CLASS;

    if (title) {
      const t = document.createElement('p');
      t.className = 'pplr-tooltip-title';
      t.textContent = title;
      wrap.appendChild(t);
    }

    if (desc) {
      const d = document.createElement('p');
      d.className = 'pplr-tooltip-desc';
      d.innerHTML = desc.replace(/\r?\n/g, '<br/>');
      wrap.appendChild(d);
    }

    if (priceTxt) {
      const p = document.createElement('p');
      p.className = 'pplr-tooltip-price';
      p.textContent = priceTxt;
      wrap.appendChild(p);
    }

    if (reference) {
      const r = document.createElement('p');
      r.className = 'pplr-tooltip-reference';
      r.textContent = `Référence: ${reference}`;
      wrap.appendChild(r);
    }

    tooltip.appendChild(wrap);
    el.dataset.tooltipEnhanced = '1';
    addInfoBtn(el);
  };

  const enhanceAll = (root = document) => {
    root.querySelectorAll(OPTION_SELECTOR).forEach(enhanceOne);
  };

  const installObserver = () => {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (!m.addedNodes?.length) continue;
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.matches?.(OPTION_SELECTOR)) {
            enhanceOne(node);
          } else {
            node.querySelectorAll?.(OPTION_SELECTOR).forEach(enhanceOne);
          }
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  };

  const init = () => {
    enhanceAll(document);
    setTimeout(() => enhanceAll(document), 300);
    setTimeout(() => enhanceAll(document), 1200);
    installObserver();

    // sécurité : si on clique ailleurs, on ferme
    document.addEventListener('pointerdown', (e) => {
      const portal = document.getElementById(PORTAL_ID);
      if (!portal) return;
      const inPortal = portal.contains(e.target);
      const inSwatch = currentAnchor?.contains(e.target);
      if (!inPortal && !inSwatch) hidePortal();
    });
  };

  window.addEventListener('pplrAppInitiated', init, { once: true });

  if (window.PPLR || document.querySelector('.product-personalizer')) {
    setTimeout(init, 0);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-media-configurator"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('product-media-configurator');
  if (!root) return;

  // Fade in base image after PPLR init
  window.addEventListener('pplrAppInitiated', () => {
    root.classList.add('pplr-initialized');
  });

  function lockBodyScroll(lock) {
    document.body.classList.toggle('pplr-zoom-lock', !!lock);
  }

  function ensureDialog() {
    let dlg = document.querySelector('dialog.pplr-zoom-dialog');
    if (dlg) return dlg;

    dlg = document.createElement('dialog');
    dlg.className = 'pplr-zoom-dialog';
    dlg.innerHTML = `
      <div class="pplr-zoom-dialog__inner">
        <button type="button" class="pplr-zoom-dialog__close" data-zoom-close aria-label="Fermer">✕</button>
        <div class="pplr-zoom-stage" data-zoom-stage></div>
      </div>
    `;
    document.body.appendChild(dlg);

    // Unlock on close (including ESC)
    dlg.addEventListener('close', () => lockBodyScroll(false));
    dlg.addEventListener('cancel', () => lockBodyScroll(false));

    // Close on X
    dlg.addEventListener('click', (e) => {
      if (e.target.closest('[data-zoom-close]')) dlg.close();
    });

    // Close on backdrop click
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });

    return dlg;
  }

  /**
   * Creates a fixed 1920x1080 (16:9) canvas and draws srcCanvas into it with "contain"
   * (keeps src aspect ratio, adds letterbox).
   */
  function drawIntoFixedAspect(srcCanvas, outW = 1920, outH = 1080) {
    const dst = document.createElement('canvas');
    dst.width = outW;
    dst.height = outH;

    const ctx = dst.getContext('2d');

    // letterbox background
    ctx.fillStyle = '#e7e7e7';
    ctx.fillRect(0, 0, outW, outH);

    const sw = srcCanvas.width;
    const sh = srcCanvas.height;

    const scale = Math.min(outW / sw, outH / sh);
    const dw = Math.round(sw * scale);
    const dh = Math.round(sh * scale);
    const dx = Math.floor((outW - dw) / 2);
    const dy = Math.floor((outH - dh) / 2);

    ctx.drawImage(srcCanvas, dx, dy, dw, dh);
    return dst;
  }

  function openZoom() {
    const srcCanvas = document.getElementById('pplr_canvas') || root.querySelector('canvas');
    if (!srcCanvas) return;

    const dlg = ensureDialog();
    const stage = dlg.querySelector('[data-zoom-stage]');
    stage.innerHTML = '';

    try {
      // Fixed 1920x1080 output (ratio kept)
      const fixed = drawIntoFixedAspect(srcCanvas, 1920, 1080);
      stage.appendChild(fixed);
    } catch (err) {
      // If canvas is blocked (tainted), show message
      const p = document.createElement('p');
      p.style.color = '#fff';
      p.style.padding = '16px';
      p.textContent = "Impossible de générer le zoom (canvas bloqué).";
      stage.appendChild(p);
    }

    lockBodyScroll(true);

    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', 'open');
  }

  // Click zoom
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pplr-zoom]');
    if (!btn) return;
    openZoom();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
